import {Box, Grid, Lead, Slot as BaseSlot, Text, Trail} from '@yandex-delivery/blocks'
import {isNotUndefined} from '@yandex-delivery/utils'
import clsx from 'clsx'
import type {ReactNode} from 'react'
import React from 'react'

import {useAction} from '../../actions'
import {renderWidget} from '../index@desktop'
import type {SlotWidgetBody, SlotWidgetProps as Props, TextWidgetConfig} from '../types'
import * as slotClasses from './Slot.classes'
import * as classes from './SlotWidget@desktop.classes'
import {isInformationSlotWidget} from './utils'

export function SlotWidget({config}: Props): ReactNode {
  const {ActionComponent: actionChildren, triggerAction: clickHandler} = useAction(config.slot.action)
  const {className} = config
  const lead: ReactNode[] = renderLead(config)
  const body: ReactNode[] = renderBody(config)
  const trail: ReactNode[] = renderTrail(config)

  return (
    <BaseSlot className={className} onClick={clickHandler} size="l">
      <Box alignItems="center" className={slotClasses.box} justifyContent="space-between">
        {lead}

        <Grid className={slotClasses.grid} direction="row">
          {body}
        </Grid>

        <Box flexDirection="row" gap="s">
          {trail}
        </Box>
        {actionChildren}
      </Box>
    </BaseSlot>
  )
}

function renderLead(config: Props['config']): ReactNode[] {
  if (config.slot.lead) {
    return [
      <Lead key={config.widget_id} size="m">
        {renderWidget(config.slot.lead)}
      </Lead>,
    ]
  }

  return []
}

function renderTrail(config: Props['config']): ReactNode[] {
  const {slot, widget_id: id} = config
  const rootKey = `.trail.${id}`

  return [slot.trail1, slot.trail2] //
    .filter(isNotUndefined)
    .map((trail, index) => renderWidget(trail, `${rootKey}.${index}`))
}

export function renderBody(config: Props['config']): ReactNode[] {
  const {slot, widget_id: id} = config
  const rootKey = `.body.${id}`

  return [slot.body1, slot.body2, slot.body3] //
    .filter(isNotUndefined)
    .map((body, bodyIndex) => {
      const bodyKey = `${rootKey}.${bodyIndex}`
      const children = getItems(body) //
        .map((item, itemIndex) => {
          // if (item.text === 'Опции') {
          //   console.log(slot)
          // }
          return renderWidget(item, `${bodyKey}.item.${itemIndex}`)
        })

      if (body.align === 'trailing') {
        return (
          <Trail key={bodyKey} className={classes.trailing}>
            {children}
          </Trail>
        )
      }

      // if (body.align === 'center') {
      //   console.log('body center', body)
      // }

      // leading по-умолчанию
      return (
        <Text key={bodyKey} className={clsx(classes.leading, {[classes.centered]: isInformationSlotWidget(id)})}>
          {children}
        </Text>
      )
    })
}

function getItems(body: SlotWidgetBody): TextWidgetConfig[] {
  const items: TextWidgetConfig[] = []

  body.title && items.push.apply(items, body.title.items)
  body.subtitle && items.push.apply(items, body.subtitle.items)

  return items
}
